<template>
  <div>
    <div class="headerNav">
      <van-nav-bar
        :title="videoName"
        left-arrow
        :fixed="true"
        style="background: var(--depYelColor)"
        @click-left="onClickLeft"
      >
        <template #left>
          <i class="iconfont iconjiantou1" style="font-size: 26px"> </i>
        </template>
      </van-nav-bar>
    </div>
    <div class="content-page" :style="{ height: height + 'px' || '100%' }">
      <div class="show-card">
        <div class="show-card-title">
          <VanImage
            round
            width="55px"
            height="55px"
            style="float: left"
            :src="logoImage"
          />
          <div class="title-content">
            <div>
              <span>星礼汇</span>
            </div>
            <div style="margin-top: 5px">
              <span>邀请您一起学习</span>
            </div>
          </div>
        </div>
        <div class="show-card-content">
          <CellGroup inset>
            <Cell>
              <template #default>
                <VanImage
                  height="180px"
                  width="364px"
                  fit="fill"
                  :src="videoCover"
                  @click="watchVideo()"
                  ><template v-slot:error>封面加载失败</template></VanImage
                >
                <div class="video-name">
                  <span>{{ videoName }}</span>
                </div>
              </template>
            </Cell>
            <Cell>
              <template #default>
                <div class="video-detail">
                  <span
                    >长按扫码查看详情<van-icon
                      name="play"
                      style="margin-left: 5px"
                  /></span>
                </div>
                <VanImage
                  width="75px"
                  height="75px"
                  class="qrcode"
                  :src="qrcodeImage"
                />
              </template>
            </Cell>
          </CellGroup>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Cell, CellGroup, Image as VanImage } from "vant";
import { getVideoOrder } from "api/onLine";
export default {
  components: { Cell, CellGroup, VanImage },
  data() {
    return {
      videoOrderId: -1,
      productId: -1,
      videoName: "视频",
      videoCover: "",
      height: null,
      logoImage: require("@/assets/watchVideo/xlh_logo.jpg"),
      qrcodeImage: require("@/assets/watchVideo/wx_qrcode.png"),
    };
  },
  created() {
    var videoOrderId = this.$route.query.videoOrderId;
    if (videoOrderId == undefined) {
      this.videoOrderId = -1;
    } else {
      this.videoOrderId = videoOrderId;
    }
    this.loadData();
  },
  mounted() {
    // 计算页面内容高度
    if (window.innerHeight) {
      this.height = window.innerHeight - 46;
    }
  },
  methods: {
    // 返回订单页
    onClickLeft() {
      this.$push({
        path: "/orders?type=-1",
      });
    },
    // 加载数据
    loadData() {
      getVideoOrder(this.videoOrderId, -1).then((res) => {
        if (res.status == 200 && res.data) {
          this.videoName = res.data.videoName;
          this.videoCover = `http://${res.data.videoCover}`;
          this.productId = res.data.productId;
        } else {
          this.$error("获取视频信息失败，请稍后重试");
        }
      });
    },
    // 跳转到视频详情页
    watchVideo() {
      this.$push({
        path: `/videoDetail?videoOrderId=${this.videoOrderId}&productId=${this.productId}`,
      });
    },
  },
};
</script>

<style scoped lang="less">
.headerNav {
  height: 46px;
  /deep/.van-nav-bar {
    color: #fff;
    .van-icon,
    .van-nav-bar__text,
    .van-nav-bar__title,
    a {
      color: inherit;
      vertical-align: middle;
    }
    .van-nav-bar__title {
      font-size: 18px;
    }
    .van-icon,
    .iconfont {
      font-size: 24px;
      vertical-align: middle;
    }
    .iconjiantou1 {
      font-size: 26px;
    }
  }
  .van-nav-bar::after {
    content: "";
    border: none;
  }
}
.content-page {
  width: 100%;
}
.show-card {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/watchVideo/bg.jpg");
  background-size: cover;
  background-position: center;
  position: relative;
  &-title {
    position: absolute;
    left: 50%;
    top: 25px;
    transform: translateX(-50%);
    width: 348px;
  }
  &-content {
    position: absolute;
    left: 50%;
    top: 100px;
    transform: translateX(-50%);
    width: 380px;
    .van-cell {
      padding: 16px 8px;
    }
    .video-name {
      font-size: 17px;
      font-weight: bold;
      margin-left: 14px;
      margin-top: 8px;
    }
    .video-detail {
      float: left;
      margin-top: 25px;
      margin-left: 18px;
      font-weight: bold;
    }
    .qrcode {
      float: right;
      margin-right: 35px;
    }
    .van-cell::after {
      border-bottom: 2px dashed #cccccc;
    }
  }
  .title-content {
    float: left;
    margin-left: 8px;
    margin-top: 6px;
    color: white;
    font-size: 15px;
  }
}
</style>
